import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const EXTRA_BONUSES = [{
  emoji: '⏱️',
  title: 'Daily Operations Toolkit',
  body: 'The 30-minute weekly routine and the 30-second post-class log that keep your whole business running like clockwork — without becoming a second job.',
  image: 'https://cdn.magicpatterns.com/uploads/7e1v3MX26RXEdWp5imd4Zy/Daily_operations.png'
}, {
  emoji: '⚡',
  title: 'Coach Quick-Reference Manual',
  body: 'Fast answers, not lessons. Technique fixes, tactical decisions, injury red flags, and business reminders — all in lookup format for the moment you actually need them.',
  image: 'https://cdn.magicpatterns.com/uploads/eQCTdbJM9gF1ecEq3CdeJM/Referencias_rapidas.png'
}, {
  emoji: '👥',
  title: 'Age-Group Class Packs',
  body: "15 more classes purpose-built for the groups a standard curriculum doesn't fit well: young kids (6–10), teens (11–17), and active 55+ players who don't need — or want — a modified class.",
  image: 'https://cdn.magicpatterns.com/uploads/a7eY1SsUePuoWbFxKcqNLe/Age_group.png'
}, {
  emoji: '🎉',
  title: 'Group Event Formats Pack',
  body: '3 ready-to-sell event formats that open up an entirely new revenue stream: corporate team-building sessions, birthday/bachelorette parties, and multi-generational family days. Book once, earn more than a week of regular lessons.',
  image: 'https://cdn.magicpatterns.com/uploads/sFXqR3ynwZ4KFMud55HdCe/Clases_en_eventos.png'
}];
export function ExtraBonuses() {
  return <div className="mt-8" data-id="element-102" data-mp="f74znh8es26">
      <div className="px-5 text-center" data-id="element-103" data-mp="3rim31gvjedy7">
        <p className="text-sm font-700 uppercase tracking-widest text-[var(--pb-lime)]" data-id="element-104" data-mp="3rjnn2auj6as2">
          Plus 4 Included Bonuses
        </p>
        <h2 className="mt-1 font-display text-2xl font-800 uppercase leading-tight text-white" data-id="element-105" data-mp="1prr26amh3okm">
          Built for the Real Work Behind Coaching
        </h2>
      </div>

      <div className="mt-5 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" role="region" aria-label="Included coaching bonuses carousel" data-id="element-106" data-mp="1kth5fvl3ofww">
        {EXTRA_BONUSES.map((bonus, index) => <article key={bonus.title} className="w-[82%] shrink-0 snap-center overflow-hidden rounded-3xl border border-white/20 bg-[#101b2d]/98 shadow-xl shadow-black/35 sm:w-[58%]" data-id="element-107" data-mp="35c9uzdmz20k8" data-mpi={index}>
            <img src={bonus.image} alt={`${bonus.title} preview`} className="aspect-[4/3] w-full object-cover" data-id="element-108" data-mp="1rx3hgw0fcrg" />
            <div className="p-4" data-id="element-109" data-mp="3o0eu27sooxcp">
              <div className="flex items-start gap-2" data-id="element-110" data-mp="3o3arlv0mdk0m">
                <span className="text-xl" aria-hidden data-id="element-111" data-mp="3sz9ne3oa24b2">
                  {bonus.emoji}
                </span>
                <div data-id="element-112" data-mp="2cl9rd3sjyyt3">
                  <p className="font-display text-xl font-800 uppercase leading-none text-white" data-id="element-113" data-mp="2ckq9to6tecfl">
                    <span className="text-[var(--pb-lime)]" data-id="element-114" data-mp="2hmfgysqx25ye">{index + 1}.</span>{' '}
                    {bonus.title}
                  </p>
                  <span className="mt-2 inline-block rounded-full border border-[var(--pb-lime)]/30 bg-[var(--pb-lime)]/10 px-2 py-1 text-[10px] font-800 uppercase tracking-wide text-[var(--pb-lime)]" data-id="element-115" data-mp="uooefhxwjnit">
                    Included Bonus
                  </span>
                </div>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-white/80" data-id="element-116" data-mp="gwi103m4vun2">{bonus.body}</p>
            </div>
          </article>)}
      </div>

      <div className="mt-2 flex items-center justify-center gap-2 px-5 text-xs font-700 text-white/55" data-id="element-117" data-mp="bzhrtjtzmbrq">
        <span data-id="element-118" data-mp="pqmocd226nxu">Swipe to explore all 4 bonuses</span>
        <ArrowRightIcon size={14} className="text-[var(--pb-lime)]" aria-hidden data-id="element-119" data-mp="ky38tajt9iqe" />
      </div>
    </div>;
}